var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"img-judge"},[_c('img',{attrs:{"src":_vm.imgSrc},on:{"error":_vm.onError,"load":_vm.onLoad}})])
}
var staticRenderFns = []

export { render, staticRenderFns }